import { IMenuItem } from '../../models/menu.model';

export const setupMenu: IMenuItem = {
  label: `Set Ups`,
  path: `set-ups`,
  id: 'MID_SET_UP_ROOT',
  icon: 'fa fa-cogs',
  children: [
    {
      path: `parameters`,
      label: `Parameters`,
      id: 'MID_SET_UP_PARAMETERS',
    },
    // {
    //   path: 'correspondence',
    //   label: 'Correspondence',
    //   children: [
    //     {
    //       label: 'Set Up',
    //       path: 'set-up',
    //     },
    //     {
    //       label: 'Template',
    //       path: 'template',
    //     },
    //     {
    //       label: 'Template Mapping',
    //       path: 'template-mapping',
    //     },
    //   ],
    // },
    { path: `companies`, label: `Companies`, id: 'MID_SET_UP_COMPANIES' },
    {
      label: 'Underwriters',
      path: 'underwriters',
      id: 'MID_SET_UP_UNDERWRITERS',
      children: [
        {
          path: 'accreditation',
          label: 'Accreditation',
          id: 'MID_SET_UP_UNDERWRITERS_ACCREDITATION',
        },
      ],
    },
    {
      path: `finance`,
      label: `Finance`,
      id: 'MID_SET_UP_FINANCE',
      children: [
        { path: `requirements`, label: `Account Requirements`, id: 'MID_SET_UP_ACCOUNTS_REQUIREMENTS' },
        {
          path: `valuation-requirements`,
          label: `Valuation Requirements`,
          id: 'MID_SET_UP_FINANCE_VALUATION_REQUIREMENTS',
        },
        {
          label: 'RBS',
          path: 'rbs',
          id: 'MID_SET_UP_FINANCE_RBS',
          children: [
            {
              path: 'risk-score-weighting',
              label: 'Risk Score Weighting',
              id: 'MID_SET_UP_FINANCE_RBS_RISK_SCORE_WEIGHTING',
            },
          ],
        },
      ],
    },
    { path: `agent-types`, label: `Agent Types`, id: 'MID_SET_UP_AGENT_TYPES' },
    { path: `configuration`, label: `Configuration`, id: 'MID_SET_UP_CONFIGURATION' },
    { path: `license-fees`, label: `License Fees`, id: 'MID_SET_UP_LICENSE_FEES' },
    { path: `attendance`, label: `Attendance`, id: 'MID_SET_UP_ATTENDANCE' },

    {
      label: 'Applications',
      path: 'applications',
      id: 'MID_SET_UP_APPLICATIONS',
      children: [
        { path: `app-setup`, label: `Application Setup`, id: 'MID_SET_UP_APP_SETUP' },
        { path: `question-setup`, label: `Application Question Setup`, id: 'MID_SET_UP_QUESTION_SETUP' },
      ],
    },
    {
      label: 'Ecowas',
      path: 'ecowas',
      id: 'MID_SET_UP_ECOWAS',
      children: [
        { path: `ecowas-setup`, label: `Ecowas Setup`, id: 'MID_SET_UP_ECOWAS_SETUP' },
        {
          path: `account`,
          label: `Ecowas Account`,
          id: 'MID_SET_UP_ACCOUNT',
          children: [{ path: `ecowas-account`, label: `Account`, id: 'MID_SET_UP_ECOWAS_ACCOUNT' }],
        },
      ],
    },
    {
      label: 'Product',
      path: 'product-mgt',
      id: 'MID_SET_UP_PRODUCT',
      children: [
        {
          path: `product-requirements`,
          label: `Product Requirements`,
          id: 'MID_SET_UP_PRODUCT_REQUIREMENTS',
        },
        { path: `product-benefits`, label: `Product Benefits`, id: 'MID_SET_UP_PRODUCT_BENEFITS' },
      ],
    },
    {
      label: 'Regulations',
      path: 'regulations',
      id: 'MID_SET_UP_REGULATIONS',
      children: [
        { path: `regulation`, label: `Regulation`, id: 'MID_SET_UP_REGULATION' },
        {
          path: `regulator-locations`,
          label: `Regulator Locations`,
          id: 'MID_SET_UP_REGULATOR_LOCATIONS',
        },
        { path: `reg-returns`, label: `Regulatory Returns`, id: 'MID_SET_UP_REG_RETURNS' },
        { path: `investments`, label: `Investments`, id: 'MID_SET_UP_REGULATION_INVESTMENTS' },
        { path: `scif`, label: `SCIF`, id: 'MID_SET_UP_REGULATION_SCIF' },
      ],
    },
    {
      label: 'RBC',
      path: 'rbc',
      id: 'MID_SET_UP_RBC',
      children: [
        { path: 'rbc', label: 'RBC Setup', id: 'MID_SET_UP_FINANCE_RBC' },
        { path: 'rbc-risk', label: 'RBC Risk', id: 'MID_SET_UP_FINANCE_RBC_RISK' },
        { path: 'rbc-feeds', label: 'RBC Feeds', id: 'MID_SET_UP_FINANCE_RBC_FEEDS' },
        {
          path: 'rbc-risk-groups',
          label: 'RBC Risk Groups',
          id: 'MID_SET_UP_FINANCE_RBC_RISK_GROUPS',
        },
        {
          path: 'rbc-risk-shocks',
          label: 'RBC Risk Shocks',
          id: 'MID_SET_UP_FINANCE_RBC_RISK_SHOCKS',
        },
        {
          path: 'rbc-ops-risk-feeds',
          label: 'Operational Risk Feeds',
          id: 'MID_SET_UP_FINANCE_RBC_OPS_RISK_FEEDS',
        },
        {
          path: 'rbc-ops-risk-grand-scores',
          label: 'Operational Risk Grand Scores',
          id: 'MID_SET_UP_FINANCE_RBC_OPS_RISK_GRAND_SCORES',
        },
        {
          path: 'rbc-ops-risk-pillars',
          label: 'Operational Risk Pillars',
          id: 'MID_SET_UP_FINANCE_RBC_OPS_RISK_PILLARS',
        },
        { path: `shocks-tables`, label: `Shocks Tables`, id: 'MID_SET_UP_SHOCKS_TABLES' },
        {
          path: 'rbc-correlation-level-1',
          label: 'RBC Correlation Level 1',
          id: 'MID_SET_UP_FINANCE_RBC_CORRELATION_LEVEL_1',
        },
        {
          path: 'rbc-correlation-level-2',
          label: 'RBC Correlation Level 2',
          id: 'MID_SET_UP_FINANCE_RBC_CORRELATION_LEVEL_2',
        },
      ],
    },
    {
      label: 'Workflow',
      path: 'workflow',
      id: 'MID_SET_UP_WORKFLOW',
      children: [
        { path: `workflow-setup`, label: `Workflow Setup`, id: 'MID_SET_UP_WORKFLOW_SETUP' },
        { path: `workflow-process`, label: `Workflow Process`, id: 'MID_SET_UP_WORKFLOW_PROCESS' },
        // { path: `tasks`, label: `Tasks`, id: 'MID_SET_UP_TASKS' },
      ],
    },
    {
      label: 'Users',
      path: 'user-mgt',
      id: 'MID_SET_UP_USERS_ROOT',
      children: [
        { path: `users`, label: `Users`, id: 'MID_SET_UP_USERS' },
        { path: `user-groups`, label: `User Groups`, id: 'MID_SET_UP_USER_GROUPS' },
      ],
    },
    { path: `currency`, label: `Currency`, id: 'MID_SET_UP_CURRENCY' },
    {
      label: 'Address',
      path: 'address',
      id: 'MID_SET_UP_ADDRESS',
      children: [
        { path: `country`, label: `Country`, id: 'MID_SET_UP_COUNTRY' },
        { path: `region`, label: `Region`, id: 'MID_SET_UP_REGION' },
        { path: `state`, label: `State`, id: 'MID_SET_UP_STATE' },
        { path: `town`, label: `Town`, id: 'MID_SET_UP_TOWN' },
      ],
    },
    {
      label: 'Health',
      path: 'health',
      id: 'MID_SET_UP_HEALTH',
      children: [{ path: `icd-codes`, label: `ICD Codes`, id: 'MID_SET_UP_ICD_CODES' }],
    },
  ],
};
